// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zoroark: PokeData = {
  "id": 571,
  "name": "zoroark",
  "height": 16,
  "weight": 811,
  "base_experience": 179,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "scratch",
    "leer",
    "agility",
    "fury-swipes",
    "scary-face",
    "feint-attack",
    "pursuit",
    "torment",
    "taunt",
    "knock-off",
    "imprison",
    "fake-tears",
    "u-turn",
    "embargo",
    "punishment",
    "night-slash",
    "nasty-plot",
    "hone-claws",
    "foul-play",
    "night-daze"
  ],
  "moves": [
    "scratch",
    "leer",
    "scary-face",
    "pursuit",
    "night-slash",
    "night-daze",
    "dark-bargain",
    "bite",
    "phantom-force",
    "dark-pulse",
    "snatch",
    "lash-out",
    "quash"
  ],
  "evolution_chain": {
    "id": 291,
    "item": null,
    "species": [
      {
        "name": "zorua",
        "order": 571,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "zoroark",
        "order": 572,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 570,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 84,
    "speed": 147,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
